import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import EmployerPageFrame from "../../components/employer/EmployerPageFrame";
import { Button } from "../../components/ui/button";

export default function StbAdvAnalyse() {
  const { id } = useParams();
  const [analyse, setAnalyse] = useState("");
  const [loading, setLoading] = useState(false);

  const starteAnalyse = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/gpt/analyse-anzeige/${id}`);
      setAnalyse(res.data.analyse);
    } catch (err) {
      console.error("Fehler bei Analyse:", err);
      alert("Fehler bei der GPT-Analyse.");
    }
    setLoading(false);
  };

  useEffect(() => {
    starteAnalyse();
  }, [id]);

  return (
    <EmployerPageFrame
      title="Anzeige analysieren"
      subtitle="Der bestehende GPT-Analysepfad bleibt erhalten, wird aber in dieselbe Employer-Workbench statt in einen zentrierten Einzelcontainer gesetzt."
      actions={(
        <Button className="dashboard-action-button" onClick={starteAnalyse}>
          Analyse neu starten
        </Button>
      )}
      contentClassName="space-y-4"
    >
      <section className="dashboard-card-shell space-y-3">
        <div>
          <span className="dashboard-kicker">GPT Analyse</span>
          <h2 className="dashboard-card-title">Anzeige #{id}</h2>
        </div>
        {loading ? (
          <p className="text-sm text-sky-700">GPT denkt gerade nach...</p>
        ) : (
          <pre className="whitespace-pre-wrap rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800">
            {analyse || "Noch keine Analyse vorhanden."}
          </pre>
        )}
      </section>
    </EmployerPageFrame>
  );
}
